export interface WarmupReporter {
  start(id: string, label: string, opts?: { totalBytes?: number }): void;
  update(id: string, text: string): void;
  progress(id: string, fraction: number): void;
  success(id: string, detail?: string): void;
  fail(id: string, error: string): void;
  note(text: string): void;
  finish(): void;
}

/**
 * A reporter that discards every event. Lets a repair function (installBrowser,
 * installEmbeddings, wipeSearxngState) be called outside the warmup flow — e.g.
 * from `doctor --fix` — without wiring a full progress reporter. Callers that
 * want the before/after lines pass their own reporter instead.
 */
export const noopReporter: WarmupReporter = {
  start() {},
  update() {},
  progress() {},
  success() {},
  fail() {},
  note() {},
  finish() {},
};

export class PlainReporter implements WarmupReporter {
  private readonly prefix: string;

  constructor(command = 'warmup') {
    this.prefix = `[wigolo ${command}]`;
  }

  private write(line: string): void {
    process.stderr.write(`${this.prefix} ${line}\n`);
  }

  start(_id: string, label: string, _opts?: { totalBytes?: number }): void {
    this.write(`${label}...`);
  }

  update(_id: string, _text: string): void {
    // no-op in plain mode
  }

  progress(_id: string, _fraction: number): void {
    // no-op in plain mode
  }

  success(id: string, detail?: string): void {
    this.write(`${id} ${detail ?? 'ok'}`);
  }

  fail(id: string, error: string): void {
    this.write(`${id} failed: ${error}`);
  }

  note(text: string): void {
    this.write(text);
  }

  finish(): void {
    // no-op
  }
}
